import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex sm:flex flex-col lg:grid grid-cols-12 gap-5 container mx-auto" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = ["initial", "enter"]
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col sm:flex-row w-full min-w-[360px] justify-start sm:justify-between items-start sm:items-center sticky top-0 p-3 bg-[#f8f9fa] rounded-sm gap-3 z-50"
}
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "flex items-center gap-5 w-fit" }
const _hoisted_7 = {
  key: 0,
  class: "bg-green-500 text-green-50 px-3 py-1 rounded-lg border text-sm"
}
const _hoisted_8 = {
  key: 0,
  id: "tips",
  class: "group w-fit flex !justify-center lg:!justify-center z-[99999]"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle cursor-pointer text-white bg-h-warning-400 px-1 !text-xl rounded-full hover:scale-75 transition-all animate-bounce-short" }, null, -1)
const _hoisted_10 = { class: "hidden absolute transition-all group-hover:flex group-focus:flex bg-white p-3 w-64 mt-8 rounded-lg !z-50 shadow-md border overflow-hidden break-words whitespace-normal" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_13 = {
  key: 2,
  id: "traditional",
  class: "flex flex-col gap-2"
}
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 3,
  class: "p-8 w-full h-[100%] sm:h-[600px] lg:h-[600px]"
}
const _hoisted_17 = {
  key: 1,
  class: "col-span-12"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "flex items-center gap-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle !text-3xl text-h-warning-400" }, null, -1)
const _hoisted_21 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseLearningMapStudent = _resolveComponent("CourseLearningMapStudent")!
  const _component_HeaderTeacherMaterials = _resolveComponent("HeaderTeacherMaterials")!
  const _component_HeaderLearningMapStudent = _resolveComponent("HeaderLearningMapStudent")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_HistoryMaterials = _resolveComponent("HistoryMaterials")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_Image = _resolveComponent("Image")!
  const _component_PDFComponent = _resolveComponent("PDFComponent")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Transcripts = _resolveComponent("Transcripts")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.showMap && _ctx.isAdaptativeLearning)
      ? (_openBlock(), _createBlock(_component_CourseLearningMapStudent, {
          key: 0,
          onOnCloseMap: _ctx.studentMap
        }, null, 8, ["onOnCloseMap"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      (
          _ctx.typeModalHeader === _ctx._typeModalHeader.TEACHER ||
          _ctx.typeModalHeader === _ctx._typeModalHeader.ADMINISTRATOR ||
          _ctx.typeModalHeader === _ctx._typeModalHeader.TEACHER_TRADITIONAL_COURSE ||
          _ctx.typeModalHeader === _ctx._typeModalHeader.TEACHER_LINEAR
        )
        ? (_openBlock(), _createBlock(_component_HeaderTeacherMaterials, {
            key: 0,
            onOnChooseMaterial: _ctx.onChooseMaterial,
            onOnDeleteObject: _ctx.onDeleteObject,
            onOnGoToEditObject: _ctx.onGoToEditObject,
            material: _ctx.currentMaterial,
            indexMaterial: _ctx.indexMaterial,
            maxIndexMaterial: _ctx.maxIndexMaterial,
            typeModalHeader: _ctx.typeModalHeader,
            isAdaptativeLearning: _ctx.isAdaptativeLearning
          }, null, 8, ["onOnChooseMaterial", "onOnDeleteObject", "onOnGoToEditObject", "material", "indexMaterial", "maxIndexMaterial", "typeModalHeader", "isAdaptativeLearning"]))
        : _createCommentVNode("", true),
      (
          (_ctx.typeModalHeader === 'STUDENT_LEARNING_MAP' ||
            _ctx.typeModalHeader === 'STATS_LEARNING_MAP') &&
          _ctx.isAdaptativeLearning
        )
        ? (_openBlock(), _createBlock(_component_HeaderLearningMapStudent, {
            key: 1,
            onOnChooseMaterial: _ctx.onChooseMaterial,
            material: _ctx.currentMaterial,
            indexMaterial: _ctx.indexMaterial,
            maxIndexMaterial: _ctx.maxIndexMaterial,
            typeModalHeader: _ctx.typeModalHeader
          }, null, 8, ["onOnChooseMaterial", "material", "indexMaterial", "maxIndexMaterial", "typeModalHeader"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
      (
          _ctx.currentMaterial?.file?.url &&
          !_ctx.loader &&
          _ctx.materials[0]?.file?.status === 'DONE'
        )
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "px-3 mt-4 flex items-center flex-col w-full",
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion
          }, [
            (_ctx.typeModalHeader === 'STUDENT')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.currentMaterial?.name), 1),
                      (!_ctx.isAdaptativeLearning && _ctx.done)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", { pt: "Concluído", en: "Concluded" })), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.done && _ctx.isVideo())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", { innerHTML: 
                    'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
                   }, null, 8, _hoisted_11)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass([
              'w-full  flex justify-end items-center gap-5 z-50',
              _ctx.isAdaptativeLearning ? 'sm:w-[50%]' : 'w-fit',
            ])
                  }, [
                    (_ctx.currentMaterial)
                      ? (_openBlock(), _createBlock(_component_HistoryMaterials, {
                          key: 0,
                          materials: _ctx.materials,
                          currentMaterial: _ctx.currentMaterial,
                          learningObjective: _ctx.learningObjective,
                          isAdaptativeLearning: _ctx.isAdaptativeLearning,
                          onOnChooseMaterial: _cache[0] || (_cache[0] = (e) => _ctx.onChooseMaterial(e)),
                          onOnCloseStudentMap: _ctx.studentMap
                        }, null, 8, ["materials", "currentMaterial", "learningObjective", "isAdaptativeLearning", "onOnCloseStudentMap"]))
                      : _createCommentVNode("", true),
                    (_ctx.isAdaptativeLearning)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_Button, {
                            class: "btn-primary p-button-sm",
                            disabled: _ctx.isDisabledBackButton(),
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onVerifyMaterials(-1)), ["prevent"])),
                            icon: "pi pi-chevron-left",
                            title: "`Voltar objeto de aprendizagem`"
                          }, null, 8, ["disabled"]),
                          _createVNode(_component_Button, {
                            class: "btn-primary p-button-sm",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onOpenFeedback('material')), ["prevent"])),
                            disabled: _ctx.isDisableNextButton,
                            icon: "pi pi-chevron-right",
                            title: "`Próximo objeto de aprendizagem`"
                          }, null, 8, ["disabled"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_Button, {
                              class: "btn-primary p-button-sm",
                              disabled: _ctx.isDisableBackButton,
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('onBackMaterial')), ["prevent"])),
                              icon: "pi pi-chevron-left",
                              title: "`Voltar objeto de aprendizagem`"
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_Button, {
                              class: "btn-primary p-button-sm",
                              onClick: _withModifiers(_ctx.onNextMaterial, ["prevent"]),
                              disabled: _ctx.isDisableNextButton,
                              icon: "pi pi-chevron-right",
                              title: "`Próximo objeto de aprendizagem`"
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ]))
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVideo())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(`${_ctx.flex} mt-4 flex-col z-10 px-4 sm:px-0`)
                }, [
                  _createVNode(_component_VideoComponent, {
                    data: _ctx.currentMaterial?.file,
                    idVideo: _ctx.currentMaterial?.file.id,
                    startTime: _ctx.time,
                    isAdaptativeLearning: _ctx.isAdaptativeLearning,
                    ref: "videoComponent"
                  }, null, 8, ["data", "idVideo", "startTime", "isAdaptativeLearning"])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.isImage())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(`${_ctx.flex} mt-4 px-4 sm:px-0`)
                }, [
                  _createVNode(_component_Image, {
                    src: _ctx.currentMaterial?.file.url,
                    alt: "material-image",
                    imageClass: "w-full h-[100%] sm:h-[600px] lg:h-[600px] object-cover",
                    preview: ""
                  }, null, 8, ["src"])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.isAudio())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: _normalizeClass(`${_ctx.flex} mt-4 px-4 sm:px-0`)
                }, [
                  _createElementVNode("audio", {
                    id: "material-audio",
                    src: _ctx.currentMaterial.file.url,
                    class: "w-full h-[100%] sm:h-[600px] lg:h-[600px]"
                  }, null, 8, _hoisted_15)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.isPdf())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(`${_ctx.flex} mt-4 px-4 sm:px-0`)
                }, [
                  _createVNode(_component_PDFComponent, {
                    url: _ctx.currentMaterial?.file.url
                  }, null, 8, ["url"])
                ], 2))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3)), [
            [_directive_motion]
          ])
        : _createCommentVNode("", true),
      (_ctx.materials[0]?.file?.status != 'DONE')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_EmptyData, {
              data: _ctx.materials[0]?.file?.status != 'DONE',
              title: `${
            _ctx.materials[0]?.file?.status === 'WAITING'
              ? _ctx.$t('objects.empty.status.waiting')
              : _ctx.$t('objects.empty.status.fail')
          }`,
              label: `${
            _ctx.materials[0]?.file?.status === 'WAITING'
              ? _ctx.$t('objects.empty.status.waitingLabel')
              : _ctx.$t('objects.empty.status.failLabel')
          }`,
              image: 'waiting_object.svg',
              imgSize: "h-40"
            }, null, 8, ["data", "title", "label", "image"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loader && _ctx.isVideo())
      ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
          (_ctx.hasTranscripts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_Transcripts, {
                  material: _ctx.currentMaterial,
                  onOnNeedsToPause: _ctx.needsToPause,
                  onOnClickDuration: _ctx.onClickDuration
                }, null, 8, ["material", "onOnNeedsToPause", "onOnClickDuration"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.showAlert,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAlert) = $event)),
      draggable: false,
      breakpoints: { '960px': '95vw', '640px': '95vw' },
      style: { width: '25vw', minWidth: '360px' },
      modal: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", { pt: `Alerta`, en: `Alert` })), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: "text-xl",
          innerHTML: 
          'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
        
        }, null, 8, _hoisted_21)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}